import CryptoJS from 'crypto-js';
export default {
    //随机生成指定数量的16进制key
    generatekey(num) {
        let library = "0123456789";
        let key = "";
        for (var i = 0; i < num; i++) {
            let randomPoz = Math.floor(Math.random() * library.length);
            key += library.substring(randomPoz, randomPoz + 1);
        }
        return key;
    },

    //加密
    encrypt(str, key) {
        let _key = key || '5F6B2AK33DASD1235E74C231B47AC8F6'
        const __key = CryptoJS.enc.Utf8.parse(_key) //将秘钥转换成Utf8字节数组
        // const iv = CryptoJS.enc.Utf8.parse(_key.substr(0, 16))
        //加密
        const encrypt = CryptoJS.AES.encrypt(JSON.stringify(str), __key, {
            // iv: iv,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        })
        return encrypt.toString()
    },
    //解密
    decrypt(str, key) {
        let _key = key || '5F6B2AK33DASD1235E74C231B47AC8F6'
        const __key = CryptoJS.enc.Utf8.parse(_key) //将秘钥转换成Utf8字节数组

        const decrypt = CryptoJS.AES.decrypt(str, __key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        })
        const _decrypt = JSON.parse(decrypt.toString(CryptoJS.enc.Utf8)) //解密后的数据
        return _decrypt
    }
}